// removed by extract-text-webpack-plugin
module.exports = {"map":"src-pages----attendees-module---map---1U-_1"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/attendees.module.scss
// module id = 454
// module chunks = 95714099722567